<template>
  <div class="container_box" id="video_box">
    <img @click="goPage" :src="require('../../assets/'+appTheme+'/comback_f.png')" class="comback" />
    <div class="van_swipe">
      <!--vant van-swipe 滑动组件 -->
      <van-swipe :show-indicators="false" @change="onChange" vertical :loop="false" ref="swipeToPage" :initial-swipe="initialSwipe">
        <van-swipe-item v-for="(item, index) in videoList" :key="index" class="product_swiper">
          <div class="video_container">
            <!--video属性
        webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
        微信内置x5内核，
        x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
        x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
        x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
        poster：封面
        src：播放地址
        -->
            <video class="video_box" loop
                   x5-video-player-fullscreen="true"
                   :src="item.video_url"
                   preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
                   x5-video-orientation
                   @click="pauseVideo" @ended="onPlayerEnded($event)"
            >
            </video>
            <!-- 封面 -->
            <img v-show="isVideoShow" class="play" @click="playvideo" :src="item.image"/>
            <!-- 播放暂停按钮 -->
            <img v-show="iconPlayShow" class="icon_play" @click="playvideo" :src="require('../../assets/'+appTheme+'/zt_icon.png')" />
          </div>
          <!-- 右侧头像、点赞、评论、分享功能 -->
          <!--          <div class="tools_right">-->
          <!--            <div class="tools_r_li">-->
          <!--              <img :src="item.tag_image" class="tag_image">-->
          <!--              <i class="iconfont icon-jiahao tag_add" v-show="!item.tagFollow"-->
          <!--                 @click="checkSubscribe(item,index)"></i>-->
          <!--              <i class="iconfont icon-duihao tag_dui" v-show="item.tagFollow"-->
          <!--                 :class="item.tagFollow?'tag_dui_active':''"></i>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeFabulous(item,index)">-->
          <!--              <i class="iconfont icon-shoucang icon_right"-->
          <!--                 :class="item.fabulous?'fabulous_active':''"></i>-->
          <!--              <div class="tools_r_num">52.1w</div>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeComment">-->
          <!--              <i class="iconfont icon-liuyan icon_right icon_right_change"></i>-->
          <!--              <div class="tools_r_num">12.5w</div>-->
          <!--            </div>-->
          <!--            <div class="tools_r_li" @click="changeShare">-->
          <!--              <i class="iconfont icon-iconfontforward icon_right"></i>-->
          <!--              <div class="tools_r_num">22.2w</div>-->
          <!--            </div>-->

          <!--          </div>-->

          <!--    密码输入弹框-->
          <div class="pwd-box-swipe" v-if="currItem.verify">
            <div class="pwd-content pwd-content-swipe">
              <div class="input-box-pwd">
                <div style="text-align: center;">密码验证</div>
                <div class="form-box">
                  <div class="pwd-box-sec">
                    <input class="pwd" v-model="passwordCurr" placeholder="请输入密码" :type="passwordType" />
                    <span class="solts" @click="switchPasswordType">
                       <van-icon name="eye" v-if="passwordType==='text'" />
                       <van-icon name="closed-eye" v-if="passwordType==='password'"  />
                    </span>
                  </div>
                  <div class="btn-box">
                    <van-button :disabled="isDisablePwdCurr" class="btn-txt" round block type="primary" @click="onSubmitPwdSwipe">
                      进入
                    </van-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--    密码输入弹框-->
          <!-- 底部作品描述 -->
          <div class="production_box">
            <!--          右边分享-->
            <div class="title-box-top justify-align">
              <span></span>
              <div class="share-box">
                <div class="share-item">
                  <img :src="require('../../assets/'+appTheme+'/f_share.png')" alt="">
                  0
                </div>
                <div class="share-item">
                  <img v-if="!item.tagFollow" :src="require('../../assets/'+appTheme+'/f_aixin.png')" alt="">
                  <img v-else @click="checkSubscribe(item,index)" :src="require('../../assets/'+appTheme+'/des_aixin.png')" alt="">
                  {{item.likes}}
                </div>
              </div>
            </div>
            <!--            <div class="production_name">-->
            <!--              @{{item.author}}-->
            <!--            </div>-->
            <div class="production_des">
              {{item.title}}
            </div>
            <div class="trailer_progress_bar">
              <div class="proress_content_box">
                <p class="pro_pone">{{ currentTime }}</p>
                <div
                  ref="progress"
                  class="progress_bar_box"
                  @mousedown="getNowWh($event)"
                  @mouseup="mouseup($event)"
                >
                  <div
                    ref="onProgress"
                    :class="[ radiusLeft ? 'on_progress_bar_child border_Radius' : 'on_progress_bar_child',]">
            <span
              v-show="!radiusLeft"
              ref="mouseDom"
              class="mouse_down"
              @mousedown.stop="mousedown($event)"
              @mouseup.stop="mouseup($event)"
            ></span>
                  </div>
                </div>
                <p class="pro_pone">{{ duration }}</p>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!--底部操作栏-->
      <!--分享弹框-->
      <div class="share_box" :class="showShareBox?'share_active':''">
        <div class="share_tips">分享到</div>
        <ul class="share_ul">
          <li class="share_li pengyouquan_li">
            <i class="iconfont icon-pengyouquan pengyouquan"></i>
          </li>
          <li class="share_li">
            <i class="iconfont icon-weixin weixin"></i>
          </li>
          <li class="share_li" @click="copyUrl">
            <i class="iconfont icon-lianjie lianjie"></i>
          </li>
          <div class="clear"></div>
        </ul>
        <div class="share_cancel" @click="cancelShare">取消</div>
      </div>
      <!--留言弹窗-->
      <van-popup v-model="commentPop" closeable :overlay="true" class="comment_container" position="bottom">
        <div class="comment_box">
          <div class="comment_top">
            12.5w条评论
            <i class="iconfont icon-guanbi1 guanbi3" @click="closeComment"></i>
          </div>
          <ul class="comment_ul">
            <div v-if="videoComment.length!=0">
              <transition-group appear>
                <li class="comment_li" v-for="(item,index) in videoComment" :key="item.id"
                    @click="replayUser(item,index,-1)">
                  <div class="comment_author_left">
                    <img :src="item.avatar">
                  </div>
                  <div class="comment_author_right">
                    <div class="comment_author_top">
                      <div class="comment_author_name">@{{item.nickname}}</div>
                      <div class="icon-shoucang1_box" @click.stop="commentLove(item,index,-1)">
                        <div class="icon_right_change"
                             :class="item.love_comment?'love_active':''">
                          <i class="iconfont icon-shoucang icon-shoucang1"></i>
                        </div>
                        <div class="shoucang1_num">{{item.love_count}}</div>
                      </div>
                    </div>
                    <div class="comment_author_text">
                      {{item.comment_content}}<span>{{item.create_time}}</span></div>
                  </div>
                  <div class="clear"></div>
                  <div class="comment_replay_box">
                    <transition-group appear>
                      <div class="comment_replay_li" v-for="(item2,index2) in item.child_comment"
                           :key="item2.id" @click.stop="replayUser(item2,index,index2)">
                        <div class="comment_replay_left">
                          <img :src="item2.avatar">
                        </div>
                        <div class="comment_replay_right">
                          <div class="comment_replay_top">
                            <div class="comment_replay_name">@{{item2.nickname}}</div>
                            <div class="icon-shoucang1_box"
                                 @click.stop="commentLove(item2,index,index2)">
                              <div class="icon_right_change"
                                   :class="item2.love_comment?'love_active':''">
                                <i class="iconfont icon-shoucang icon-shoucang1"></i>
                              </div>
                              <div class="shoucang1_num">{{item2.love_count}}</div>
                            </div>
                          </div>
                          <div class="comment_replay_text">
                            <span v-if="item.user_id!=item2.be_commented_user_id && item.user_id!=item2.user_id">回复 {{item2.be_commented_nickname}}：</span>
                            {{item2.comment_content}}
                            <span>{{item2.create_time}}</span></div>
                        </div>
                        <div class="clear"></div>
                      </div>
                    </transition-group>
                  </div>
                </li>
              </transition-group>
            </div>
            <div class="no_message" v-if="videoComment.length==0">
              <i class="iconfont iconfont_style icon-zanwupinglun"></i>
              <div class="no_message_tips">暂无评论</div>
            </div>
          </ul>
        </div>
      </van-popup>
      <!--留言输入-->
      <div class="comment_input_box_hover"></div>
      <div class="comment_input_box" v-show="commentPop">
        <!--<form action="#" class="comment_form">-->
        <input :placeholder="commentPlaceholder" class="comment_input" v-model="comment_text" ref="content"
               @keyup.enter="checkComment"/>
        <!--</form>-->
        <div class="comment_input_right" @click="checkComment">
          <i class="iconfont icon-fasong comment_i" :class="canSend?'comment_i_active':''"></i>
        </div>
      </div>
    </div>
    <!--    密码输入弹框-->
    <div class="pwd-box" v-if="isShowPwd">
      <div class="pwd-content">
        <van-nav-bar title="密码验证"
                     left-arrow
                     @click-left="onClickLeft"
        />
        <div class="input-box-pwd">
          <div class="form-box">
            <div class="pwd-box-sec">
              <input class="pwd" v-model="password" placeholder="请输入密码" :type="passwordType" />
              <span class="solts" @click="switchPasswordType">
                 <van-icon name="eye" v-if="passwordType==='text'" />
                 <van-icon name="closed-eye" v-if="passwordType==='password'"  />
              </span>
            </div>
            <div class="btn-box">
              <van-button :disabled="isDisablePwd" class="btn-txt" round block type="primary" @click="onSubmitPwd">
                进入
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <tabBar></tabBar>
    </div>
    <!--    密码输入弹框-->
  </div>
</template>


<script>
import Vue from "vue";
import tabBar from "@/components/tabBar";
import {
  Swipe,
  SwipeItem,
  Toast
} from 'vant';
import {getListData,factoryDes,getWechat} from "@/api/factory";
Vue.use(Swipe, Toast).use(SwipeItem);
const jweixin = require('jweixin-module');
let videoProcessInterval;
export default {
name: "factoryDes2",
  data(){
    let u = navigator.userAgent;
  return{
    appTheme:this.$store.state.appTheme,
    passwordType: 'password',//输入框类型
    isShowPwd:false, // true 显示密码弹框 false 不显示
    password:'', // 密码
    passwordCurr:'',
    isDisablePwdCurr:false,
    isDisablePwd:false,
    current: 0,
    videoList: [],
    isVideoShow: true, // 封面图
    playOrPause: true,
    video: null,
    iconPlayShow: true, // 暂停按钮显示
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
    isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    tabIndex: 0,
    showShareBox: false,//展示分享框
    commentPop: false,//是否展示评论弹框
    // 评论相关
    comment_text: '',//评论输入内容
    canSend: false,//是否可以发送
    videoComment: [],
    commentPlaceholder: '留下你精彩的评论吧',//评论Placeholder
    replayUserData: '',
    to_comment_id: '',
    videoProcess: 0,//视频播放进度
    loading: false, // 加载状态
    finished: false, // 是否加载
    page: 1,
    currentPage: 1,
    immediate: false,
    finishedTxt: '没有更多了~',
    statusType: 'null',
    pVideo: null, //视频容器
    currItem: '',
    initialSwipe: 0, // 初始位置索引值
    currentTime: "00:00", //当前时间
    duration: "00:00", //总时长
    pvideo: null, //视频容器
    timer: null, //定时器
    radiusLeft: false,
   }
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },
  beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
    // document.querySelector('body').removeAttribute('style')
    console.log('离开界面')
    clearInterval(this.timer);
    this.timer = null;
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    // console.log('离开界面')
    clearInterval(this.timer);
    this.timer = null;
    // document.querySelector('body').setAttribute('style', '')
    next()
  },
  components:{
    tabBar
  },
  watch: {
    //监听输入变化
    comment_text(newV, oldV) {
      newV == '' ? this.canSend = false : this.canSend = true
    }
  },
  mounted() {
    // this.pVideo = document.querySelectorAll('video')[this.current];
  },
  created() {
    console.log('id',this.$route.query.id)
    // this.currItem = this.$route.query.item
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload",()=>{
      // var itemObj = this.$route.query.item
      // var item = JSON.stringify(itemObj)
      let itemObj = this.$route.query.id
      let item = JSON.stringify(itemObj)
      this.$store.commit("setFactoryItem",item)
      sessionStorage.setItem("factoryItem",item)
      // console.log('eeee')
    })
    if (this.$store.state.factoryItem != ''){ // 后退进来/刷新
      console.log('后退进来/刷新')
      var item = sessionStorage.getItem('factoryItem')
      var currItem = JSON.parse(item)
      this.live_id = currItem.id

    } else {
      console.log('正常进来')
      this.live_id = this.$route.query.id
    }
  this.getDes()
  },
  methods: {
    onClickLeft(){
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    switchPasswordType() { // 显示密码
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
      // console.log(this.passwordType)
    },
    onSubmitPwd(){ // 密码提交
      if (this.password == ''){
        this.$toast('请输入密码')
      }else {
        this.getDes()
      }
    },
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        console.log('ios')
      } else {
        console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      var data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          var weChat = res.data
          console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            console.log('ready',this.currItem)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              const id = that.currItem.id
              let http = window.location.protocol+'//'
              let url = window.location.hostname // 获取当前访问（域名）
              let urlPath  =http+url+`/factoryDes2?id=${id}` // `https://jpzs-zst.itos.cn/factoryDes2?id=${id}`
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: that.currItem.title,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.currItem.image,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: that.currItem.title,
                desc:' ',
                link: urlPath, // keyi
                imgUrl: that.currItem.image,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });
            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    getDes(){
      let data = {
        password:this.password
      }
      factoryDes(this.live_id,data).then(res => {
        if(res.code == 200)
        {
          this.isShowPwd = false
          let currData = res.data
          currData.verify = false
          this.currItem = currData
          console.log('this.currItem',this.currItem)
          this.video_src = res.data.video_url
          this.video_cover = res.data.image
          this.video_title = res.data.title
          // video.play();
          setTimeout(() => {
            //通知父组件关闭
            // console.log('播放')
            this.getShareInfo()
            this.getList();

          }, 1000);

        } else if (res.code==403){ // 显示直播间密码
          this.isShowPwd = true
          this.$toast(res.message)
        } else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data.data)
          var arr = res.data.data
          arr.unshift(this.currItem)
          let newarr = this.unique(arr);
           // console.log('newarr',newarr)
          that.videoList = newarr
          // console.log(that.videoList)
          // setTimeout(() => {
          //   //通知父组件关闭
          //   // console.log('播放')
          //   var video = document.querySelectorAll('video')[this.current];
          //   this.pVideo = document.querySelectorAll('video')[this.current];
          //   this.playvideo();
          // }, 100);


          if(!this.isiOS){ // 安卓
            console.log('安卓')
            setTimeout(() => {
              //通知父组件关闭
              console.log('播放')
              var video = document.querySelectorAll('video')[this.current];
              this.pVideo = document.querySelectorAll('video')[this.current];
              this.playvideo();
            }, 1000);
          }else { // ios
            console.log('ios')
            var video = document.querySelectorAll('video')[this.current];
            this.pVideo = document.querySelectorAll('video')[this.current];
            this.isVideoShow = true // 封面图显示
            this.iconPlayShow = true; // // 暂停按钮显示

          }


          // 加载状态结束
          this.loading = false;

          if (this.currentPage == res.data.last_page){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data==0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    unique(newarr) { // 数组数据调用unique方法去除重复数据。
      const res = new Map();
      return newarr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      var s_to = that.videoList.length
      console.log(s_to)
      this.current = s_to
      getListData(data).then(res => {

        if(res.code == 200)
        {

          var arr = this.videoList.concat(res.data.data);
          let newarr = this.unique(arr);
          // console.log('newarr',newarr)
          that.videoList = newarr
          this.initialSwipe = s_to
          // this.$refs.swipeToPage.swipeTo(s_to);

          this.isVideoShow = true // 封面图显示
          this.iconPlayShow = true; // // 暂停按钮显示

          setTimeout(() => {
            //通知父组件关闭
            console.log('播放')
            this.pVideo = document.querySelectorAll('video')[this.current];
            var video = document.querySelectorAll('video')[this.current];
            this.playvideo();
            Toast.clear()
          }, 920);
          // 加载状态结束
          this.loading = false;
          if (res.data.current_page == res.data.last_page) { // 数据全部加载完成
            this.finished = true;
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    //获取评论
    getComment() {
      //setTimeout模拟Ajax请求
      setTimeout(() => {
        let data = [{
          "comment_id": 297,
          "p_id": 0,
          "comment_content": "你好，我叫蓝湛",
          "love_count": 0,
          "create_time": "1月前",
          "user_id": 78634,
          "nickname": "蓝忘机\uD83C\uDF1F",
          "avatar": "http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575449277018pF3XL.jpg",
          "be_commented_user_id": 0,
          "be_commented_nickname": "",
          "be_commented_avatar": "",
          "child_comment": [{
            "comment_id": 298,
            "p_id": 296,
            "comment_content": "蓝二公子，今天天气不错",
            "love_count": 1,
            "create_time": "7天前",
            "user_id": 55163,
            "nickname": "魏婴",
            "avatar": "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKPJb1k8zia02PjVibdaDJ83JIDGm0hIsY34kAlXyZMT6FMBibdw6rhdPPjpxtp6d8B75x5Kpicxp2gqw/132",
            "be_commented_user_id": 78480,
            "be_commented_nickname": "chenchen",
            "be_commented_avatar": "http://thirdwx.qlogo.cn/mmopen/vi_32/icxHc0Ym1p4hQAFAUnjpxDPMkEUyojnibBj9wUSS2OmibiazdBAicSLpoicricVYP6QG6XicjTzQPx9koMPqcGfhTOy5qA/132",
            "love_comment": true
          },],
          "love_comment": false
        }, {
          "comment_id": 281,
          "p_id": 0,
          "comment_content": "楼主好帅，我要嫁给你！！",
          "love_count": 0,
          "create_time": "1月前",
          "user_id": 74164,
          "nickname": "冰雪奇缘2",
          "avatar": "http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575449298299M3V50.jpg",
          "be_commented_user_id": 0,
          "be_commented_nickname": "",
          "be_commented_avatar": "",
          "child_comment": [],
          "love_comment": false
        }];//获取评论数据
        this.videoComment = [...this.videoComment, ...data];
        let to_comment_id = this.to_comment_id;
        if (to_comment_id != 0) {
          //从评论列表进来回复
          this.getCommentDetail(to_comment_id);
        }
      }, 500)
    },
    //获取单个评论
    getCommentDetail(to_comment_id) {
      let obj = {
        action: 'show_comment_info',
        comment_id: to_comment_id
      };
      setTimeout(() => {
        let index;
        let item = res.data;
        this.videoComment.map((v, i) => {
          v.child_comment.map((v2, i2) => {
            if (v2.comment_id == to_comment_id) {
              index = i;
            }
          });
        });
        setTimeout(() => {
          //对评论重新排序，存在to_comment_id的时候排至第一个
          let firstComment = this.videoComment.splice(index, 1);
          this.videoComment.unshift(firstComment[0]);
          //重设回复人
          item.index = 0;
          item.index2 = 0;
          this.replayUserData = item;
          this.commentPlaceholder = `回复 @${item.nickname}：`;
          this.$refs.content.focus();
        }, 10)
      }, 500)
    },
    //检测评论内容
    checkComment() {
      if (this.comment_text == '') {
        Toast('评论内容不能为空')
      } else {
        let comment_id = 0, p_id = '', p_user_id = '', content = this.comment_text;
        if (this.replayUserData != '') {
          comment_id = this.replayUserData.comment_id;
          p_id = this.replayUserData.p_id;
          p_user_id = this.replayUserData.user_id;
        }
        this.sendComment(comment_id, p_id, p_user_id, content)
      }
    },
    //发送评论
    sendComment(comment_id, p_id, p_user_id, content) {
      this.comment_text = '';
      this.isSending = true;
      setTimeout(() => {
        let newData = {
          "comment_id": comment_id,
          "p_id": p_id,
          "comment_content": content,
          "love_count": 0,
          "create_time": "刚刚",
          "user_id": p_user_id,
          "nickname": "游客",//当前用户
          "avatar": 'https://profile.csdnimg.cn/B/1/E/3_ridingfish',//当前用户头像
          "be_commented_user_id": this.replayUserData.user_id,
          "be_commented_nickname": this.replayUserData.nickname,
        }
        if (this.replayUserData == '') {
          //回复作品
          this.videoComment.splice(0, 0, newData)
        } else {
          let index = this.replayUserData.index;
          let index2 = this.replayUserData.index2;
          if (this.replayUserData.index2 == -1) {
            //回复一级人
            this.videoComment[index].child_comment.splice(0, 0, newData)
          } else {
            //回复二级人
            this.videoComment[index].child_comment.splice(index2, 0, newData)
          }
        }
        this.replayUserData = '';
        this.isSending = false;
      }, 500)
    },
    //评论点赞
    commentLove(item, index, index2) {
      let comment_id = item.comment_id,
        user_id = item.user_id,
        love_comment = item.love_comment,
        love_flag = 0;//0:取消点赞；1：点赞
      if (love_comment) {
        //取消点赞
        love_flag = 0
      } else {
        //添加点赞
        love_flag = 1
      }
      //setTimeout模拟Ajax请求
      setTimeout(() => {
        if (index2 == -1) {
          //点赞一级评论
          this.videoComment[index].love_comment = !this.videoComment[index].love_comment;
          if (love_flag == 1) {
            this.videoComment[index].love_count++
          } else {
            this.videoComment[index].love_count--
          }
        } else {
          //点赞二级评论
          this.videoComment[index].child_comment[index2].love_comment = !this.videoComment[index].child_comment[index2].love_comment
          if (love_flag == 1) {
            this.videoComment[index].child_comment[index2].love_count++
          } else {
            this.videoComment[index].child_comment[index2].love_count--
          }
        }
      }, 500)
    },
    //点击回复
    replayUser(item, index, index2) {
      item.index = index;
      item.index2 = index2;
      this.replayUserData = item;
      this.commentPlaceholder = `回复 @${item.nickname}：`;
      this.$refs.content.focus();
    },
    //弹出评论窗口
    changeComment() {
      this.commentPop = true;
      this.videoComment = [];
      this.getComment()
    },
    //关闭评论弹窗
    closeComment() {
      this.commentPop = false;
      this.commentPlaceholder = '留下你精彩的评论吧';
      this.replayUserData = '';
    },
    //改变菜单
    changeTab(index) {
      this.tabIndex = index
    },
    //改变收藏状态
    changeFabulous(item, index) {
      this.videoList[index].fabulous = !this.videoList[index].fabulous
    },
    //展示分享弹窗
    changeShare() {
      this.showShareBox = true
    },
    //取消分享
    cancelShare() {
      this.showShareBox = false
    },
    //滑动改变播放的视频
    onChange(index) {
      //改变的时候 暂停当前播放的视频
      clearInterval(this.timer);
      this.videoProcess = 0;
      this.passwordCurr = '';
      this.currentTime = '00:00'
      let video = document.querySelectorAll('video')[this.current];
      video.pause();
      this.showShareBox = false; // 分享弹框隐藏
      this.current = index;
      this.live_id = this.videoList[this.current].id
      this.currItem = this.videoList[this.current]
      console.log(this.currItem)
      // this.shopBig = false // 关闭购物袋
      // this.shareShow = false
      this.posterUrl = ''
      // this.init()
      //非ios切换直接自动播放下一个
      if (index == this.videoList.length - 1) { // 最后一个 加载更多
        console.log('xiangdeng')
        if (this.finished==false){
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
          this.moreList()
        } else {
          this.$toast('加载完毕')

        }
      } else {
        console.log('bu xiang deng')
        if (!this.currItem.verify) { // true 需要密码 false 不需要
          let video = document.querySelectorAll('video')[this.current];
          video.pause();

          if(!this.isiOS){
            this.isVideoShow = false // 封面图显示
            this.iconPlayShow = false; // // 暂停按钮显示
            setTimeout(() => {
              this.pauseVideo()
            }, 100)
          }else{
            //ios官方禁止video自动播放，未找到合适的方法，如果您发现了，麻烦告诉我一下谢谢啦

            this.isVideoShow = true // 封面图显示
            this.iconPlayShow = true; // // 暂停按钮显示
          }
        } else {
          this.isVideoShow = true // 封面图显示
        }

      }

      this.getShareInfo() // 重新初始化微信注入
    },
    onSubmitPwdSwipe(){// 列表密码验证
      if (this.passwordCurr == ''){
        this.$toast('密码不能为空')
      } else {
        let data = {
          password:this.passwordCurr
        }
        factoryDes(this.currItem.id,data).then(res => {
          if(res.code == 200)
          {
            // console.log(res.data)
            this.passwordCurr = ''
            let curData = res.data
            let newArr2 =  this.videoList // 清掉直播
            newArr2.forEach((element,index) => {
              // console.log(element,"element")
              if (element.id == curData.id) {
                // console.log(index)
                element.verify = false
                element.video_url = curData.video_url
              }
            });
            // console.log(newArr2)
            this.currItem.verify = false
            this.videoList = newArr2 // 赋值给video 列表
            this.isVideoShow = false // 封面图显示
            let video = document.querySelectorAll('video')[this.current];
            video.pause();
            setTimeout(() => {
              this.pauseVideo()
            }, 100)

          } else if (res.code==403){ // 显示直播间密码错误
            // this.isShowPwd =true
            this.$toast(res.message)
          }
          else
          {
            this.$toast(res.message)
          }
        })
      }

    },
    //滑动改变播放的视频
    onChange1(index) {
      //改变的时候 暂停当前播放的视频
      clearInterval(this.timer);
      this.videoProcess = 0;
      var video = document.querySelectorAll('video')[this.current];
      video.pause();
      this.showShareBox = false; // 分享弹框隐藏
      this.current = index;
      // this.init()
      //非ios切换直接自动播放下一个
      if (index == this.videoList.length - 1) { // 最后一个 加载更多
        console.log('xiangdeng')
        if (this.finished==false){
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
          this.moreList()
        } else {
          this.$toast('加载完毕')
        }
      } else {
        console.log('bu xiang deng')
      }
      this.pauseVideo()
      // if(!this.isiOS){
      //   console.log('1')
      //   this.isVideoShow = false; // // 封面图隐藏
      //   setTimeout(() => {
      //     this.pauseVideo()
      //   }, 100)
      // }else{
      //   //ios官方禁止video自动播放，未找到合适的方法，如果您发现了，麻烦告诉我一下谢谢啦
      //   this.iconPlayShow = true; // // 封面图显示
      // }
    },
    // 开始播放
    playvideo(event) {
      let video = document.querySelectorAll('video')[this.current];
      // console.log(video)
      // console.log("playvideo：" + this.current);
      this.isVideoShow = false;
      this.iconPlayShow = false;
      this.showShareBox = false;
      video.play();
      this.pVideo = document.querySelectorAll('video')[this.current];
      this.timer = setInterval(this.setProgress, 60);
      // console.log('总时长', video.duration)
      this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示

      window.onresize = function () {
        video.style.width = window.innerWidth + "px";
        video.style.height = window.innerHeight + "px";
      }

    },
    pauseVideo(){ //暂停\播放
      var video = document.querySelectorAll('video')[this.current];
      this.pVideo = document.querySelectorAll('video')[this.current];
      if (video.paused || video.ended) {
        // console.log('播放')
        video.play();
        this.timer = setInterval(this.setProgress, 60);
        this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
        this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示
        // console.log('shjian', video.currentTime)
        this.iconPlayShow = false // 暂停按钮隐藏
      } else {
        console.log('暂停')
        video.pause();
        this.iconPlayShow = true // // 暂停按钮显示
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //设置进度条
    setProgress() {
      this.pVideo = document.querySelectorAll('video')[this.current];
      var video = document.querySelectorAll('video')[this.current];
      let progress = this.$refs.progress[this.current]; //获取进度条父元素
      let onProgress = this.$refs.onProgress[this.current]; //获取变化进度条的元素
      let mouseDom = this.$refs.mouseDom[this.current];
      // console.log(mouseDom)
      this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示
      // console.log('总时长', this.duration)
      //换算,视频没有结束或者被暂停
      if (!video.ended) {
        this.radiusLeft = false;
        let percent = video.currentTime / video.duration; //得出比例
        mouseDom && (mouseDom.style.left = percent * progress.offsetWidth + "px");
        onProgress && (onProgress.style.width = percent * progress.offsetWidth + "px");
      } else {
        //视频已结束
        onProgress && (onProgress.style.width = "100%");
        this.radiusLeft = true;
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //设置进度条
    setProgress1() {
      this.pVideo = document.querySelectorAll('video')[this.current];
      var video = document.querySelectorAll('video')[this.current];
      let progress = this.$refs.progress[this.current]; //获取进度条父元素
      let onProgress = this.$refs.onProgress[this.current]; //获取变化进度条的元素
      let mouseDom = this.$refs.mouseDom[this.current];
      // console.log(mouseDom)
      this.currentTime = this.timeFomat(video.currentTime); //当前播放的时间,格式化时间格式后展示
      this.duration = this.timeFomat(video.duration); //总时长，格式化时间格式后展示
      // console.log('总时长', this.duration)
      //换算,视频没有结束或者被暂停
      if (!video.ended) {
        this.radiusLeft = false;
        let percent = video.currentTime / video.duration; //得出比例
        mouseDom && (mouseDom.style.left = percent * progress.offsetWidth + "px");
        onProgress && (onProgress.style.width = percent * progress.offsetWidth + "px");
      } else {
        //视频已结束
        onProgress && (onProgress.style.width = "100%");
        this.radiusLeft = true;
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    //点击当前位置，设置进度条
    getNowWh(event) {
      console.log(event)
      let ev = event || window.event;
      this.videoSeek(ev.offsetX);
    },
    //传入当前点击的偏移量，换算当前视频时间，并播放
    videoSeek(startx) {
      var video = document.querySelectorAll('video')[this.current];
      if (video.paused || video.ended) {
        video.play();
        this.enhanceVideoSeek(startx);
      } else {
        this.enhanceVideoSeek(startx);
      }
    },
    //根据鼠标拖动的距离，换算进度条
    enhanceVideoSeek(moveWidth) {
      console.log(moveWidth)
      var video = document.querySelectorAll('video')[this.current];
      clearInterval(this.timer);
      let progress = this.$refs.progress[this.current]; //获取进度条父元素
      let onProgress = this.$refs.onProgress[this.current]; //获取变化进度条的元素
      let percent = moveWidth / progress.offsetWidth;
      onProgress && (onProgress.style.width = percent * progress.offsetWidth + "px");
      video.currentTime = percent * video.duration;
      this.timer = setInterval(this.setProgress, 60);
    },
    vueTouch:function(s,e){
      console.log(s,e)
    },
    //鼠标按下
    mousedown(event) {
      console.log(event)
      let that = this;
      let ev = event || window.event;
      let _target = ev.target;
      let startx = ev.clientX;
      let sb_bkx = startx - ev.target.offsetLeft;
      let allwh = this.$refs.progress[this.current].clientWidth;
      let ww = document.documentElement.clientWidth;
      let wh = window.innerHeight;
      //阻止事件冒泡
      if (ev.preventDefault) {
        ev.preventDefault();
      } else {
        ev.returnValue = false;
      }
      //移动
      document.onmousemove = function (ev) {
        let evt = ev || window.event;
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        if (
          evt.clientY < 0 ||
          evt.clientX < 0 ||
          evt.clientY > wh ||
          evt.clientX > ww
        ) {
          return false;
        }


        let endx = evt.clientX - sb_bkx;
        //设置拖动有效区域
        if (endx > -1 && endx < allwh) {
          _target.style.left = endx + "px";
          that.enhanceVideoSeek(endx);
        } else {
          //超出区域，置空拖动事件
          document.onmousemove = null;
        }
      };
    },
    //鼠标放开
    mouseup(e) {
      document.onmousemove = null;
    },
    //订阅暂停事件
    stopPlay() {
      Watcher.$on("stop", (data) => {
        this.pauseVideo();
      });
    },
    /* 时间格式化 */
    timeFomat(time) {
      let h = Math.floor(time / 3600);
      let m = Math.floor((time % 3600) / 60);
      let s = Math.floor(time % 60);
      m = m >= 10 ? m : "0" + m;
      s = s >= 10 ? s : "0" + s;
      if (h === 0) {
        return m + ":" + s;
      }
      return h + ":" + m + ":" + s;
    },
    onPlayerEnded(player) { //视频结束
      this.isVideoShow = true
      this.current += this.current
    },
    goPage(){
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    //复制当前链接
    copyUrl() {
      let httpUrl = window.location.href;
      var oInput = document.createElement('input');
      oInput.value = httpUrl;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      alert("链接复制成功")
    }
  }
}
</script>

<style lang="scss" scoped>
.pwd-box{
  position: fixed;width: 100%;height: 100%;z-index: 1009;background: #F5F5F5;top: 0;
  left: 0;

}
.input-box-pwd{
  margin: 95px 24px 0;background: #ffffff;padding: 30px 0 40px;border-radius: 10px;
  .form-box{
    padding: 20px;
  }
  .pwd-box-sec{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    font-size: 28px;border-radius: 10px;position:relative;
    .solts{
      position: absolute;right: 20px;top: 10px;font-size: 32px;color: #666666;
    }
  }
  .pwd{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    border: none;font-size: 28px;border-radius: 10px;
  }
  .btn-box{
    //margin-top: 40px;
  }
  .btn-txt{
    font-size: 30px;background: #FDD80D;border-color: #FDD80D;color: #333333;
  }
}
.pwd-box-swipe{
  position: absolute;width: 100%;height: 100%;z-index: 1009;background: #f5f5f561;top: 0;
  left: 0;
}
.pwd-content-swipe{
  margin-top: 350px;
}
/deep/.van-nav-bar{
  background: #FDD80D;
}
/deep/.van-nav-bar .van-icon {
  color: #333333;
}
.clear {
  clear: both;
}
.back_i{
  position: fixed;
  top: 20px;
  left: 10px;
  width: 28px;
  z-index: 10;
}


.video-player {
  height: 100vh;
  width: 100vw;
}
.title-box-top{
  color: #FFFFFF;margin-right: 20px;
  .share-box{
    display: inline-block;
  }
  .share-item{
    text-align: center;display: inline-block;margin-left: 30px;
    img{
      width: 50px;display: block;height: auto;
    }
  }
}
.product_swiper {
  width: 100vw;
  height: 100vh;
}

.van_swipe {
  width: 100vw;
  height: 100vh;
  /*max-width: 550px;*/
  /*margin: 0 auto;*/
  position: relative;
}

.van-swipe {
  width: 100%;
  height: 100%;
}

.container_box {
  width: 100vw;
  height: 100vh;
  background: #000;
}

.video_box {
  object-fit: fill !important;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

video {
  object-position: 0 0;
}

.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 120px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play,
.platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}

/*头像， 点赞，转发 */
.tag_image {
  width: 50px;
  height: 50px;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0px 0px 10px #9d9d9d;
}


.tag_dui_active {
  opacity: 0;
  animation: showFollow 1.4s ease-in-out 0s;
}

.tag_add_num {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
}

@keyframes showFollow {
  0% {
    opacity: 1;
    color: #fff;
    background: #F44;
    transform: rotate(-180deg) scale(1);
  }
  35% {
    opacity: 1;
    color: #f44;
    background: #fff;
    transform: rotate(0deg) scale(1.2);
  }
  80% {
    opacity: 1;
    color: #f44;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    display: none;
    color: #f44;
    transform: scale(0);
  }
}

.tools_right {
  z-index: 1001;
  position: absolute;
  right: 16px;
  bottom: 180px
}

.tools_r_li {
  margin-bottom: 20px;
  color: #fff;
  font-size: 14px;
  position: relative;
}

.tools_r_li:last-child {
  margin-bottom: 0px;
}

.icon_right {
  margin-bottom: 5px;
  font-size: 42px;
  display: block;
  text-shadow: 0px 0px 10px #9d9d9d;
  /*transition: .5s;*/
}

.production_box {
  z-index: 1001;
  position: absolute;
  /* right: 16px; */
  bottom: 0;
  text-align: left;
  padding: 30px 0 40px;
  color: #fff;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  background: linear-gradient(transparent, #000);
  /* 标准的语法 */
}

.production_name {
  font-size: 28px;
  margin-bottom: 10px;
}

.production_des {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 62px;padding: 10px;
  font-size: 26px;margin-left: 20px;
}


.production_title {
  margin-left: 4px;
}

//.border_progress {
//  width: 0;
//  height: 1px;
//  background: #bababa;
//  position: absolute;
//  top: 0;
//  transition: .1s all;
//}


.icon-shoucang {
  transition: .5s all;
}

//.fabulous_active {
//  color: #f44;
//  animation: showHeart .5s ease-in-out 0s;
//}

/*animation-name：用来调用@keyframes定义好的动画，与@keyframes定义的动画名称一致*/
/*animation-duration ：指定元素播放动画所持续的时间*/
/*animatino-timing-function ： 和transition中的transition-timing-function 中的值一样。根据上面@keframes中分析的animation中可能存在多个小动画，因此这里的值设置是针对每一个小动画所在时间范围内的属性变换速率。*/
/*animation-delay：定义在浏览器开始执行动画之前等待的时间，这里是指整个animation执行之前的等待时间，而不是上面说的多个小动画*/
/*animation-iteration-count：定义动画的播放次数，其通常为整数，默认是1,；取值为infinite，动画将无限次的播放。*/
/*animation-direction：主要用来设置动画播放方向*/
@keyframes showHeart {
  0% {
    color: #f44;
    transform: scale(1);
  }

  25% {
    color: #fff;
    transform: scale(0);
  }

  80% {
    color: #f44;
    transform: scale(1.2);
  }

  100% {
    color: #f44;
    transform: scale(1);
  }
}

/*分享样式*/
.share_hover {
  position: fixed;
  display: none;

}

.share_box {
  position: fixed;
  bottom: -300px;
  width: 100%;
  z-index: 1002;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: .5s;
}

.share_tips {
  text-align: center;
  line-height: 38px;
  color: #333;
}

.share_ul {
  box-sizing: border-box;
  padding: 0 25px 25px;
  border-bottom: 1px solid #e8e8e8;
}

.share_li {
  float: left;
  width: 33%;
  text-align: center;
}

.share_li i {
  font-size: 44px;
}

.share_cancel {
  text-align: center;
  line-height: 48px;
  color: #777;
  text-align: center;
}

.pengyouquan {
  color: #47D000;

}

.pengyouquan_li {
  animation: rotating 8s linear infinite
}

@keyframes rotating {
  from {
    transform: rotate(0)
  }

  to {
    transform: rotate(360deg)
  }
}

.weixin {
  color: #20CA2E;
}

.lianjie {
  color: #cdcdcd;
}

.share_active {
  bottom: 0px;
}

/*评论样式*/
::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

:-moz-placeholder {
  color: rgba(0, 0, 0, 0.20);;
}

::-moz-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.20);
}

.comment_container {
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.comment_box {
  padding: 0 15px 52px 15px;
}

.comment_top {
  text-align: center;
  font-size: 26px;
  color: #000;
  line-height: 40px;padding-top: 20px;
}

.guanbi3 {
  float: right;
  font-size: 12px;
  padding: 0 10px;
  position: absolute;
  right: 6px;
}

.comment_li {
  margin-bottom: 20px;
  font-size: 14px;
  text-align: left;
}

.comment_author_left {
  float: left;
}

.comment_author_left img {
  width: 55px;
  height: 55px;
  border-radius: 50%;display: inline-block;margin-right: 10px;
}

.comment_author_right {
  margin-left: 46px;
  padding-top: 4px;
}

.comment_author_top {
  position: relative;
}

.comment_author_name {
  margin-bottom: 6px;
  color: #777;font-size: 28px;
}

.icon-shoucang1_box {
  position: absolute;
  right: 0px;
  top: 0;
  text-align: center;
  color: #777;
}

.comment_author_text {
  color: #555;font-size: 26px;
  margin-bottom: 10px;
  padding-right: 35px;
}

.comment_replay_box {
  padding-left: 46px;
  box-sizing: border-box;
}

.comment_replay_li {
  margin-bottom: 10px;
}

.comment_replay_left {
  float: left;
}

.comment_replay_left img {
  width: 60px;
  height:60px;
  border-radius: 50%;
}

.comment_replay_right {
  margin-left: 35px;
  padding-top: 2px;
}

.comment_replay_top {
  position: relative;
  margin-bottom: 6px;
}

.comment_replay_text {
  padding-right: 35px;
  margin-bottom: 10px;
  color: #555;
}

.comment_author_text span, .comment_replay_text span {
  color: #999;
  font-size: 24px;
  margin-left: 6px;
}

.shoucang1_num {
  text-align: center;
  width: 30px;
  font-size: 26px;
  /* right: -4px; */
  position: relative;
}

.comment_ul {
  height: 400px;
  overflow-y: auto;margin-top: 50px;
}

.comment_input_box {
  position: fixed;
  bottom: 0;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  padding: 10px 15px;
  box-sizing: border-box;
}

/*.comment_form {*/
/**/
/*}*/
.comback{
  width: 54px;height: auto;display: block;left: 30px; top: 30px;z-index: 22;position: absolute;
}
.comment_input {
  border: none;
  resize: none;
  width: 80%;
  float: left;
  color: #555;
  caret-color: #f44;
}

.comment_input_right {
  float: right;
}

.comment_i {
  font-size: 26px;
  color: #999;
  transition: .3s;
}

.comment_i_active {
  color: #f44;
}

.icon-zanwupinglun {
  font-size: 100px;
  color: #777;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(80px);
}

.v-enter-active,
.v-leave-active {
  transition: all .5s ease;
}

/*添加进场效果*/
.v-move {
  transition: all 1s ease;
}

.v-leave-active {
  position: absolute;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.love_active {
  color: #f44;
}

.trailer_progress_bar {
  //width: 100%;
  padding: 0 10px;
  overflow: hidden;
  position: relative;
  .proress_title {
    width: 100%;
    height: 100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
    p {
      color: #fff;
      font-size: 12px;
      font-weight: 600;
    }
  }
  .proress_content_box {
    width: 100%;
    overflow: hidden;
    display: flex;
    //padding: 0 24px;
    justify-content: center;
    p {
      color: #fff;
      font-weight: 400;
      font-size: 24px;margin: 0;
    }
    .pro_pone {
    }
    .progress_bar_box {
      flex: 0.9;
      margin: 6px 16px 0 16px;
      height: 8px;
      background: rgba(205, 206, 209, 0.2);
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      .on_progress_bar_child {
        width: 0;
        height: 100%;
        background: #cdced1;
        border-radius: 4px 0px 0px 4px;
        // overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1001;
        .mouse_down {
          position: absolute;
          width: 5px;
          height: 16px;
          top: 50%;
          margin-top: -8px;
          left: 100%;
          background: #ff5001;
          border-radius: 3px;
          z-index: 1002;
          cursor: pointer;
        }
      }
      .on_progress_bar_child.border_Radius {
        border-radius: 4px;
      }
    }
  }
}
/deep/.van-nav-bar .van-icon {
  color: #333333;
}
/deep/.van-nav-bar{
  background: #FDD80D;
}

</style>
